import React from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * HOC that provides queryClient to a class component
 *
 * @param {React.ComponentType} Component - The component to wrap
 * @returns {React.FunctionComponent} - The wrapped component with queryClient prop
 */
const withQueryClient = Component => props => {
    const queryClient = useQueryClient();
    return <Component {...props} queryClient={queryClient} />;
};

export default withQueryClient;
